import http from '@plugin/axios'
import { formatDate } from '@utils/common/index'
import Dialog from '@utils/common/dialog'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'
import Form from '@utils/form'
interface ExportOptions {
  url: string;
  name?: string;
  baseURL?: string;
  data?: object;
  suffix?: string;
  fileName?: string;
}
export async function tableExport(options: ExportOptions) {
  const datetime = formatDate(new Date(), 'yyyyMMddHHmmss')
  const res = await http<any>({
    url: options.url,
    baseURL: options.baseURL,
    data: options.data,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    widthHeader: true,
    responseType: 'blob'
  })
  const blob = res.data
  const download = (() => {
    if (options.fileName) return options.fileName
    if (!options.name) return ''
    if (options.name.includes('.')) return options.name
    return `${options.name || 'file'}-${datetime}${options.suffix ? '.' + options.suffix : ''}`
  })()
  let link: any = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = download
  link.click()
  link = null
}

interface PrintOption {
  url: string;
  baseURL?: string;
  data?: object;
}
export async function tablePrint(options: PrintOption) {
  const res = await http<any>({
    url: options.url,
    baseURL: options.baseURL,
    data: options.data,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    widthHeader: true,
    responseType: 'blob'
  })
  const blob = res.data
  window.open(window.URL.createObjectURL(blob))
}

interface ImportOption {
  url: string;
  baseURL?: string;
  data?: object;
}

export async function tableImport(options: ImportOption) {
  return http({
    url: options.url,
    baseURL: options.baseURL,
    data: options.data,
    headers: { 'Content-type': 'multipart/form-data' }
  })
}

// 弹框导入
const tip = {
  props: ['value'],
  methods: {
    download(this: any, options: any) {
      const { url, baseURL, data, downloadName } = options
      tableExport({
        url,
        baseURL,
        data,
        name: downloadName
      })
    }
  },
  render(this: any, h: any): any {
    const { url, baseURL, data, downloadTip, downloadName } = this.value || {}
    if (!url) {
      return h('div', { style: 'font-size: 12px;display: flex; align-items: center;' }, [downloadTip || ''])
    }
    const dowmTemplate = () => this.download({ url, baseURL, data, downloadName })
    return h(
      'div',
      { style: 'font-size: 12px;display: flex; align-items: center;' },
      [
        h('el-link', { props: { type: 'primary' }, on: { click: dowmTemplate }}, [this.$t('performance.qualitativescore.download')]),
        downloadTip || ''
      ]
    )
  }
}

const fileNoAttrs = {
  autoUpload: false,
  onChange(this: any, file: any) {
    this.$emit('input', file.raw)
  }
}

const dForm = new Form('performance.qualitativescore')
  .setSpan(24)
  .add('fild').component(UploadSelect).col(24).attrs(fileNoAttrs).required()
  .add('info').label('').component(tip)

const dialog = new Dialog('performance.qualitativescore')
  .title('dialogTitle')
  .dialog({ width: '400px' })
  .form(dForm)

interface DialogImportOptions {
  url: string;
  baseURL?: string;
  data?: object;
  fileKey?: string;
  downloadUrl?: string;
  downloadBaseURL?: string;
  downloadData?: object;
  downloadTip?: string;
  downloadName?: string;
}

export async function dialogImport(this: any, options: DialogImportOptions) {
  const { url, baseURL, data = {} as any, fileKey = 'file', downloadUrl, downloadBaseURL, downloadData, downloadTip, downloadName } = options
  const downloadOptions = { url: downloadUrl, baseURL: downloadBaseURL, data: downloadData, downloadTip, downloadName }
  const vm: any = await dialog.open({ attrs: { row: { info: downloadOptions }}})
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.set(key, data[key])
  })
  formData.set(fileKey, vm.data.fild)
  await tableImport({
    url,
    baseURL,
    data: formData
  })
  this.reset()
}
